import { render, staticRenderFns } from "./Index64New.vue?vue&type=template&id=6e3b004c&scoped=true&"
import script from "./Index64New.vue?vue&type=script&lang=js&"
export * from "./Index64New.vue?vue&type=script&lang=js&"
import style0 from "./Index64New.vue?vue&type=style&index=0&id=6e3b004c&lang=less&scoped=true&"
import style1 from "./Index64New.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3b004c",
  null
  
)

export default component.exports